import Vue from 'vue';
import Router from 'vue-router';
import Util from '@/config/Util';
Vue.use(Router);

const routes = [{
    path: '*',
    redirect: '/home'
  },
  {
    name: 'home',
    component: () => import('../page/page/page'),
    meta: {
      title: '首页',
      keepAlive:true
    }
  },
  {
    path: '/login',
    component: () => import('../page/account/login'),
    meta: {
      title: '登录',
      public: true
    },

  },
  {
    name: 'login',
    path: '/login/password',
    component: () => import('../page/account/password'),
    meta: {
      title: '登录',
      public: true,
      isretail:true
    },

  },
  {
    path: '/login/phone',
    component: () => import('../page/account/phonelogin'),
    meta: {
      title: '手机号登录',
      public: true
    },

  },
  {
    path: '/login/register',
    component: () => import('../page/account/register'),
    meta: {
      title: '注册',
      public: true
    },

  },
  {
    path: '/user/index',
    component: () => import('../page/user/index'),
    name: 'user',
    meta: {
      title: '会员中心'
    }
  },
  {
    path: '/user/info',
    component: () => import('../page/user/info/detail'),
    name: 'user',
    meta: {
      title: '账号管理'
    }
  },
  {
    name:'address',
    path: '/user/address',
    component: () => import('../page/user/address/list'),
    meta: {
      title: '我的地址',
      isretail:true
    }
  },
  {
    path: '/user/address/edit',
    name: 'addressedit',
    component: () => import('../page/user/address/edit'),
    meta: {
      title: '修改地址',
      isretail:true
    }
  },
  {
    path: '/user/order/ordertrains',
    name: 'ordertrains',
    component: () => import('../page/user/order/ordertrains'),
    meta: {
      title: '全部订单'
    }
  },
  {
    path: '/user/favorite',
    component: () => import('../page/user/favorite/list'),
    meta: {
      title: '我的收藏'
    }
  },
  {
    name:'coupon',
    path: '/user/coupon/list',
    component: () => import('../page/user/coupon/list'),
    meta: {
      title: '我的优惠券',
      isretail:true
    }
  },
  {
    path: '/user/coupon/available',
    component: () => import('../page/user/coupon/available'),
    meta: {
      title: '领取优惠券',
      isretail:true
    }
  },
  
  {
    path: '/user/order',
    name: 'myorder',
    component: () => import('../page/user/order/list'),
    meta: {
      title: '我的订单'
    }
  },
  {
    path: '/user/order/:id',
    name: 'myorder',
    component: () => import('../page/user/order/list'),
    meta: {
      title: '我的订单',
      keepAlive: true // 需要缓存
    }
  },
  {
    path: '/user/orderdetail',
    name: 'orderdetail',
    component: () => import('../page/user/order/info'),
    meta: {
      title: '我的订单',
      isretail:true
    }
  },
  {
    name: 'logistics',
    component: () => import('../page/user/order/logistics'),
    meta: {
      title: '订单追踪',
      isretail:true
    }
  },
  {
    path: '/user/aftersale',
    component: () => import('../page/user/aftersale/list'),
    meta: {
      title: '售后'
    }
  },
  {
    path: '/user/aftersale/apply',
    component: () => import('../page/user/aftersale/apply'),
    meta: {
      title: '申请售后'
    }
  },
  {
    path: '/user/aftersale/detail',
    component: () => import('../page/user/aftersale/detail'),
    meta: {
      title: '服务单详情'
    }
  },
  {
    path: '/user/aftersale/track/:id',
    component: () => import('../page/user/aftersale/track'),
    meta: {
      title: '进度详情'
    }
  },
  {
    path: '/product/:id',
    component: () => import('../page/product/detail'),
    meta: {
      title: '商品详情',
      isretail:true
    }
  },
  {
    name: 'search',
    component: () => import('../page/product/searchgoods'),
    meta: {
      title: '查询商品'
    }
  },
  {
    name: 'productlist',
    component: () => import('../page/product/list'),
    meta: {
      title: '商品列表',
      keepAlive:true
    }
  },
  {
    name: 'cart',
    component: () => import('../page/cart/index'),
    meta: {
      title: '购物车',
      public: true
    }
  },
  {
    path: '/order',
    name: 'order',
    component: () => import('../page/shipping/order'),
    meta: {
      title: '确认订单',
      isretail:true
    }
  },
  {
    path: '/pay',
    name: 'pay',
    component: () => import('../page/money/pay'),
    meta: {
      title: '支付',
      isretail:true
    }
  },
  {
    path: '/paysuccess',
    name: 'paysuccess',
    component: () => import('../page/money/paysuccess'),
    meta: {
      title: '支付成功',
      isretail:true
    }
  },
  {
    path: '/setpwd',
    name: 'setpwd',
    component: () => import('../page/user/setpwd/setpwd'),
    meta: {
      title: '设置支付密码'
    }
  },
  {
    name: 'category',
    component: () => import('../page/category/index'),
    meta: {
      title: '分类'
    }
  },
  {
    name: 'authorizedinvitation',
    component: () => import('../page/user/authorizedinvitation/authorizedinvitation'),
    meta: {
      title: '授权邀请'
    }
  },
  {
    name: 'authorizedinvitationsub',
    component: () => import('../page/user/authorizedinvitation/authorizedinvitationsub/authorizedinvitationsub'),
    meta: {
      title: '发展下级'
    }
  },
  {
    name: 'mynvitationqrcode',
    component: () => import('../page/user/authorizedinvitation/authorizedinvitationsub/mynvitationqrcode/mynvitationqrcode'),
    meta: {
      title: '我的邀请码'
    }
  },
  {
    name: 'inviteregist',
    component: () => import('../page/account/inviteregist'),
    meta: {
      title: '邀请注册',
      public: true,
      isretail:true
    }
  },
  {
    name: 'payearnestmoney',
    component: () => import('../page/account/payearnestmoney'),
    meta: {
      title: '缴纳保证金'
    }
  },
  {
    name: 'earnestwaitcheck',
    component: () => import('../page/account/earnestwaitcheck'),
    meta: {
      title: '退保审核中'
    }
  },
  {
    name: 'mywallet',
    component: () => import('../page/user/wallet/mywallet'),
    meta: {
      title: '我的钱包'
    }
  },
  {
    name: 'rechargemoney',
    component: () => import('../page/user/wallet/rechargemoney'),
    meta: {
      title: '余额充值'
    }
  },
  {
    name: 'subrechargerecord',
    component: () => import('../page/user/subrechargerecord/subrechargerecord'),
    meta: {
      title: '下级充值单据'
    }
  },
  {
    name: 'myrechargerecord',
    component: () => import('../page/user/wallet/myrechargerecord/myrechargerecord'),
    meta: {
      title: '充值单据'
    }
  },
  {
    name: 'subrechargerecorddetail',
    component: () => import('../page/user/subrechargerecord/subrechargerecorddetail/subrechargerecorddetail'),
    meta: {
      title: '下级充值单据详情'
    }
  },
  {
    name: 'assist',
    path: '/assist/assist',
    component: () => import('../page/assist/assist'),
    meta: {
      title: '物料铺'
    }
  },
  {
    name: 'applyupgrade',
    component: () => import('../page/user/applyupgrade/applyupgrade'),
    meta: {
      title: '申请升级',
      isretail:true
    }
  },
  {
    name: 'teamagent',
    component: () => import('../page/user/team/teamagent'),
    meta: {
      title: '团队代理'
    }
  },
  {
    name: 'diffprice',
    component: () => import('../page/user/diffprice/diffprice'),
    meta: {
      title: '差价查询'
    }
  },
  {
    name: 'usercfa',
    component: () => import('../page/user/usercfa/usercfa'),
    meta: {
      title: '授权证书'
    }
  },
  {
    name: 'largeloancostlog',
    component: () => import('../page/user/costlog/largeloancostlog'),
    meta: {
      title: '大货明细'
    }
  },
  {
    name: 'assistcostlog',
    component: () => import('../page/user/costlog/assistcostlog'),
    meta: {
      title: '物料明细'
    }
  },
  {
    name:'coffer',
    component: () => import('../page/assist/coffer'),
    meta: {
      title: '小金库返利'
    }
  },
  {
    name: 'set',
    component: () => import('../page/user/set/set'),
    meta: {
      title: '设置'
    }
  },
  {
    name: 'setaccountpwd',
    component: () => import('../page/user/setpwd/setaccountpwd'),
    meta: {
      title: '修改登录密码'
    }
  },
  {
    name: 'brank',
    component: () => import('../page/user/set/brank/brank'),
    meta: {
      title: '银行卡列表'
    }
  },
  {
    name: 'setbrank',
    component: () => import('../page/user/set/brank/brankaddorupd'),
    meta: {
      title: '设置银行卡'
    }
  },
  {
    name: 'retailpage',
    component: () => import('../page/retailshop/retailpage/retailpage.vue'),
    meta: {
      title: '首页',
      isretail:true
    }
  },
  {
    name:'integralpage',
    component:()=>import('../page/retailshop/retailpage/integralpage.vue'),
    meta:{
      title:'积分商品',
      isretail:true
    }
  },
  {
    name:'retailintegraldetail',
    component:()=>import('../page/retailshop/retailuser/retailintegraldetail.vue'),
    meta:{
      title:'积分明细',
      isretail:true
    }
  },
  {
    name: 'retailuser',
    component: () => import('../page/retailshop/retailuser/retailuser.vue'),
    meta: {
      title: '我的',
      isretail:true
    }
  },
  {
    name: 'retailcart',
    component: () => import('../page/retailshop/retailcart/retailcart.vue'),
    meta: {
      title: '购物车',
      isretail:true
    }
  },
  {
    name:'retailorder',
    component:()=> import('../page/retailshop/retailuser/retailorder.vue'),
    meta:{
      title:'我的订单',
      isretail:true
    }
  },
  {
    name:'retailship',
    component:()=> import('../page/retailshop/retailship/retailship.vue'),
    meta:{
      title:'确认订单',
      isretail:true
    }
  },
  {
    name:'retailbindwx',
    component:()=>import('../page/retailshop/retailuser/retailbindwx.vue'),
    meta:{
      title:'绑定微信',
      isretail:true
    }
  },
  {
    name:'retailsupplementinfo',
    component:()=>import('../page/retailshop/retailuser/retailsupplementinfo.vue'),
    meta:{
      title:'补充个人信息',
      isretail:true
    }
  },
  {
    name:'cloundorder',
    component:()=> import('../page/user/clound/cloundorder.vue'),
    meta:{
      title:'云微商管理'
    }
  },
  {
    name:'gmclound',
    component:()=>import('../page/user/clound/gmclound.vue'),
    meta:{
      title:'云微商返利'
    }
  },
  {
    name:'cloundorderlist',
    component:()=> import('../page/user/clound/cloundorderlist.vue'),
    meta:{
      title:'我的订单'
    }
  },
  {
    name:'cloundorderdetail',
    component:()=> import('../page/user/clound/cloundorderdetail.vue'),
    meta:{
      title:'订单明细'
    }
  },
  {
    name:'cloundorderdeal',
    component:()=> import('../page/user/clound/cloundorderdeal.vue'),
    meta:{
      title:'订单处理'
    }
  },
  {
    name:'referralreward',
    component:()=>import('../page/user/referralrewardrecord/index.vue'),
    meta:{
      title:'小金库'
    }
  },
  {
    name:'referralrewardrecord',
    component:()=>import('../page/user/referralrewardrecord/referralrewardrecord.vue'),
    meta:{
      title:'大货小金库'
    }
  },
  {
    name:'cloudwithdraw',
    component:()=> import('../page/user/clound/cloudwithdraw.vue'),
    meta:{
      title:'收支明细'
    }
  },
  {
    name:'logisticstrajectory',
    component:()=>import('../page/user/order/logisticstrajectory/logisticstrajectory.vue'),
    meta:{
      title:'物流轨迹',
      isretail:true
    }
  },
  {
    name:'newawardcard',
    component:()=>import('../page/user/newawardcard/newawardcard.vue'),
    meta:{
      title:'新人奖励卡',
      isretail:true
    }
  },
  {
    name:'retailsignin',
    component:()=>import('../page/retailshop/retailuser/retailsignin.vue'),
    meta:{
      title:'会员签到',
      isretail:true
    }
  },
  {
    name:'earnestmoney',
    component:()=> import('../page/account/earnestmoney'),
    meta:{
      title:'保证金'
    }
  },{
    name:'headnavdetail',
    component:()=> import('../page/product/headnavdetail.vue'),
    meta:{
      title:'产品列表'
    }
  },
  {
    name:'ideal',
    component:()=>import('../page/idealmodule/ideal/ideal.vue'),
    meta:{
      title:'创建意见及反馈'
    }
  },
  {
    name:'idealindex',
    component:()=>import('../page/idealmodule/ideal/idealindex.vue'),
    meta:{
      title:'意见及反馈'
    }
  },
  {
    name:'ideallist',
    component:()=>import('../page/idealmodule/ideal/ideallist.vue'),
    meta:{
      title:'我的列表'
    }
  },
  {
    name:'idealdetail',
    component:()=>import('../page/idealmodule/ideal/idealdetail.vue'),
    meta:{
      title:'意见及反馈详情'
    }
  },
  {
    name:'retailset',
    component:()=>import('../page/retailshop/set/set.vue'),
    meta:{
      title:'用户设置',
      isretail:true
    }
  },
  {
    name:'mproductlist',
    component:()=>import('../page/product/mproductlist.vue'),
    meta:{
        title:'品牌馆',
        isretail:true
      }
  },
  {
    name:'mproductdetail',
    component:()=>import('../page/product/mproductdetail.vue'),
    meta:{
        title:'品牌明细',
        isretail:true
    }
  },
  {
    name:'setmyqrcode',
    component:()=>import('../page/user/set/setmyqrcode.vue'),
    meta:{
      title:'我的微信二维码'
    }
  },
  {
    name:'retailindex',
    component:()=>import('../page/retailshop/retailpage/retailindex.vue'),
    meta:{
      title:'首页',
      isretail:true
    }
  },
  {
    name:'foodmore',
    component:()=>import('../page/knowledge/food/foodmore/foodmore.vue'),
    meta:{
      title:'能不能吃',
      isretail:true
    }
  },
  {
    name:'food',
    component:()=>import('../page/knowledge/food/food/food.vue'),
    meta:{
      title:'食物描述',
      isretail:true
    }
  },
  {
    name:'fooddetail',
    component:()=>import('../page/knowledge/food/food/fooddetail.vue'),
    meta:{
      title:'详情',
      isretail:true
    }
  },
  {
    name:'foodsearch',
    component:()=>import('../page/knowledge/food/foodsearch/foodsearch.vue'),
    meta:{
      title:'搜索',
      isretail:true
    }
  },
  {
    name:'wikimore',
    component:()=>import('../page/knowledge/wiki/wikimore/wikimore.vue'),
    meta:{
      title:'百科',
      isretail:true
    }
  },
  {
    name:'wikiarticle',
    component:()=>import('../page/knowledge/wiki/wikiarticle/wikiarticle.vue'),
    meta:{
      title:'百科列表',
      isretail:true
    }
  },
  {
    name:'wikiarticledetail',
    component:()=>import('../page/knowledge/wiki/wikiarticle/wikiarticledetail.vue'),
    meta:{
      title:'百科详情',
      isretail:true
    }
  },
  {
    name:'wikisearch',
    component:()=>import('../page/knowledge/wiki/wikisearch/wikisearch.vue'),
    meta:{
      title:'百科搜索',
      isretail:true
    }
  },
  {
    name:'communityindex',
    component:()=>import('../page/community/communityindex.vue'),
    meta:{
      title:'育儿',
      isretail:true,
      public:true,
      keepAlive:true
    }
  },
  {
    name:'communitymy',
    component:()=>import('../page/community/my/communitymy.vue'),
    meta:{
      title:'我的',
      isretail:true,
    }
  },
  {
    name:'addquestion',
    component:()=>import('@/page/community/answerquestion/addquestion.vue'),
    meta:{
      title:'创建问题',
      isretail:true,
    }
  },
  {
    name:'addrecommend',
    component:()=>import('@/page/community/recommend/addrecommend.vue'),
    meta:{
      title:'创建话题',
      isretail:true,
    }
  },
  {
    name:'recommenddetail',
    component:()=>import('@/page/community/recommend/recommenddetail.vue'),
    meta:{
      title:'话题正文',
      isretail:true,
    }
  },
  {
    name:'answerlist',
    component:()=>import('@/page/community/answerquestion/answerlist.vue'),
    meta:{
      title:'全部回答',
      isretail:true,
    }
  },
  {
    name:'answerdetail',
    component:()=>import('@/page/community/answerquestion/answerdetail.vue'),
    meta:{
      title:'回答详情',
      isretail:true,
    }
  },
  {
    name:'addanswer',
    component:()=>import('@/page/community/answerquestion/addanswer.vue'),
    meta:{
      title:'回复问题',
      isretail:true,
    }
  },
  {
    name:'addcomment',
    component:()=>import('@/page/community/answerquestion/addcomment.vue'),
    meta:{
      title:'评论',
      isretail:true,
    }
  },
  {
    name:'commentlist',
    component:()=>import('@/page/community/answerquestion/commentlist.vue'),
    meta:{
      title:'更多评论',
      isretail:true,
    }
  },
  {
    name:'addrecomment',
    component:()=>import('@/page/community/recommend/addrecomment.vue'),
    meta:{
      title:'评论',
      isretail:true,
    }
  },
  {
    name:'recommentlist',
    component:()=>import('@/page/community/recommend/recommentlist.vue'),
    meta:{
      title:'更多评论',
      isretail:true,
    }
  },
  {
    name:'updatemyinfo',
    component:()=>import('@/page/community/my/updatemyinfo.vue'),
    meta:{
      title:'个人信息',
      isretail:true,
    }
  },
  {
    name:'drawlottery',
    component:()=>import('@/page/drawlottery/drawlottery.vue'),
    meta:{
      title:'抽奖',
      isretail:true,
    }
  },
  {
    name:'newdrawlottery',
    component:()=>import('@/page/drawlottery/newdrawlottery.vue'),
    meta:{
      title:'新抽奖',
      isretail:true,
    }
  },
  {
    name:'drawlotterycard',
    component:()=>import('@/page/drawlottery/drawlotterycard.vue'),
    meta:{
      title:'奖品',
      isretail:true,
    }
  },
  {
    name:'retailhalfprice',
    component:()=>import('@/page/retailshop/retailuser/retailhalfprice.vue'),
    meta:{
      title:'半价活动',
      isretail:true,
    }
  },
  {
    name:'drawlotterycarddetail',
    component:()=>import('@/page/drawlottery/drawlotterycarddetail.vue'),
    meta:{
      title:'奖品详情',
      isretail:true,
    }
  },
  {
    name:'retailcoupon',
    component:()=>import('@/page/retailshop/retailcoupon/retailcoupon.vue'),
    meta:{
      title:'活动专区',
      isretail:true,
    }
  },
  {
    name:'upgradeactive',
    component:()=>import('@/page/user/actives/upgradeactive.vue'),
    meta:{
      title:'升级活动'
    }
  },
  {
    name:'diffhalflist',
    component:()=>import('@/page/user/order/diffhalflist.vue'),
    meta:{
      title:'下级半价订单'
    }
  },
  {
    name:'phoneteamsale',
    component:()=>import('../page/user/phoneteamsale/phoneteamsale.vue'),
    meta:{
      title:'销售奖励'
    }
  },
  {
    name:'investcard',
    component:()=>import('../page/drawlottery/investcard.vue'),
    meta:{
      title:'充值奖励卡券'
    }
  },
  {
    name:'TeamPerformanceDetail',
    component:()=>import('../page/user/TeamPerformanceDetail/TeamPerformanceDetail.vue'),
    meta:{
      title:'销售业绩明细'
    }
  },
  {
    name:'RedPaper',
    component: () => import('../page/drawlottery/RedPaper'),
    meta: {
      title: '红包',
      isretail:true,
    }
  },
  {
    name: 'RedPaperPerson',
    component: () => import('../page/drawlottery/RedPaperPerson'),
    meta: {
      title: '红包领取记录',
      isretail:true,
    }
  },
];

// add route path
routes.forEach(route => {
  route.path = route.path || '/' + (route.name || '');
});


const router = new Router({
  routes: routes
});

router.beforeEach((to, from, next) => {
  if (typeof window.entryUrl === 'undefined' || window.entryUrl === '') {
    window.entryUrl = location.href.split('#')[0];
  }
  Util.title(to.meta.title);
  
  if (!Util.abp.session.userId && !to.meta.public) {
    next({
      name: "login",
      query: to.query
    });
  } else if (!!Util.abp.session.userId && to.name == 'login') {
    Util.title(to.meta.title);
    //如果是零售端跳转零售端用户界面
    if(!Util.abp.userInfo)
    {
      next({
        name: "login",
        query: to.query
      });
    }
    else
    {
        if (Util.abp.userInfo.memberLevelModel.isRetail) {

          next({
            name: "retailuser",
          });
        } else {
          next({
            name: "user",
          });
        }
    }
    
  }
  
  //跳转到首页
  if(to.name=='earnestwaitcheck'&&Util.abp.session.userId&&Util.abp.userInfo&&!Util.abp.userInfo.memberLevelModel.isRetail&&!Util.abp.userInfo.isTBEnter)
  {
    next({
      name: "home",
    });
  }
  if(to.name!='earnestwaitcheck'&&Util.abp.session.userId&&Util.abp.userInfo&&!Util.abp.userInfo.memberLevelModel.isRetail&&Util.abp.userInfo.isTBEnter)
  {
    next({
      name: "earnestwaitcheck",
    });
  }

  //拦截零售端的界面
  if(Util.abp.session.userId && Util.abp.userInfo&&Util.abp.userInfo.memberLevelModel.isRetail&&!to.meta.isretail)
  { 
      next({
        name: "retailuser",
      });
  }

  


  if (Util.abp.session.userId && Util.abp.userInfo && !Util.abp.userInfo.isEarnestMoney && to.name != 'payearnestmoney') {
    next({
      name: 'payearnestmoney'
    })
  }
  if (Util.abp.session.userId && Util.abp.userInfo && Util.abp.userInfo.isEarnestMoney && to.name == 'payearnestmoney') {
    next({
      name: 'user'
    })

  }
  //跳转支付后无法返回上个页面
  next();
});

export {
  router
};